module.exports = __webpack_public_path__ + "img/牛蒡根.0b7dbde9.jpg";